import styled from 'styled-components';  
import HrImg from '../../img/hr-maru.png';
import Img1 from '../../img/route5.png';
import Img2 from '../../img/route6.png';
import Img3 from '../../img/route7.png';
import TableLeft from './TableLeft';
import TableRight from './TableRight';
import Table from './Table';

const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`
const Header =styled.h2`
    padding: 15px;
    font-size: 1.5rem;
    background-color: orange;
    color: rgb(255, 255, 255);
    border-radius: 7px;
`
const News =styled.div`
    width: 80%;
    margin: auto;
    margin-bottom: 100px;
`

const svgCorse =<svg className="h-8 w-8 text-orange-400 inline"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round" >  <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />  <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" /></svg>
const OptionHada: React.VFC = () => {
  return (
    <Main>
        <p className='text-center text-2xl font-bold'>オプションコース</p>
        <img className='mt-2 mb-5' src={HrImg} width={'100%'} alt='hr' />
        
        {/* ******************************************************************************************************************************************************************* */}
        <Header>土佐塾幼児クラス(年中・年長)</Header>
        <TableLeft 
            text1={'読み書きの基礎や数の概念を習得して学びの土台をつくるクラスです。'}
            text2={'就学前に学びの土台をつくっておくことで、小学生になってからアドバンテージを得られると共に、勉強に対してポジティブな姿勢で取り組めるようになることを目指します。'}
            src={Img1}
        />
        <Table 
            td1={'開講日'} td2={'月曜日（月２回）　'}
            td3={'時間'} td4={'(月)15:00～15:40'}
            td5={'月謝'} td6={'5,280円/月（税込）～　※管理費 880円別途'}
            td7={''} td8={'※STEAM教育コースと併用の場合、'}
            td9={''} td10={'2,640円/月～となります。'}
        />

        {/* ******************************************************************************************************************************************************************* */}
        <Header>まなびのlab(小１～６)</Header>
        <p className='mt-5'>{svgCorse}<span>小１・小２</span></p>
        <p className='mt-2'>１年生、２年生…読み書き・計算・読解力など基礎力養成を大切にしながら、教科の枠に縛られない学びで思考力や表現力を養います。</p>
        <p className='mt-2'>プリントのみの学習ではなく、立体教材を用いた学習や理科実験を行うことで、学びへの興味を深めていきます。</p>
        <p className='mt-5'>{svgCorse}<span>小３～小６</span></p>
        <p className='mt-2'>３年生以上…読解力、語彙力を養うことに重点を置きます。プリントのみの学習ではなく、カードゲームや身体を動かしながらの学びなど、楽しみながら幅広く学習していきます。</p>
        <p className='mt-2'>さらに、社会科に関する知識を身につけることも目指します。</p>
        <Table 
            td1={'開講日'} td2={'火曜日・小２　水曜日・小１　金曜日・小３～小６（月３～４回）'}
            td3={'時間'} td4={'(火)・小２ 16:15～17:15'}
            td5={''} td6={'(水)・小１ 16:15～17:15'}
            td7={''} td8={'(金)・小３～小６ 18:30～19:30'}
            td9={'月謝'} td10={'11,000/月（税込）～ ※管理費1,650円別途 '}
            td11={''} td12={'※STEAM教育コースと併用の場合、'}
            td13={''} td14={'8,800円/月～となります。'}
        />

    </Main>
    
  );
}
export default OptionHada;